import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

/**
 * The door to the proposal history (12.3): a small link, next to the proposals
 * counter when there is one — decided against a sixth button in the controls
 * row and against the counter alone being clickable, which nobody would guess.
 * Rendered only when the caller holds `view_submissions` (the container checks
 * the CAPABILITY, computed server-side, not `owner_id === user.id`).
 */
const SubmissionsHistoryLink: React.FC<{ experienceId: string; variant?: 'inline' | 'standalone' }> = ({
  experienceId,
  variant = 'inline',
}) => {
  const { t } = useTranslation()

  return (
    <Link
      to={`/experiences/${experienceId}/submissions`}
      className="text-sm font-normal underline text-primary dark:text-accent-blue-300 hover:opacity-80"
      data-testid="submissions-history-link"
    >
      {variant === 'inline' ? t('dashboardExperienceDetail.submissionsDetails') : t('submissions.title')}
    </Link>
  )
}

export default SubmissionsHistoryLink
